import React, { useContext, useLayoutEffect, useRef, useState } from 'react'
import { withRouter } from 'react-router-dom'
import SidebarContext from './SidebarContext'

const MOBILE_BREAKPOINT = 1280
const VIEWPORT_MARGIN = 8

const SidebarSubmenu = ({ title, items, anchorRef, history, location, onKeep, onNavigate }) => {
  const { logout } = useContext(SidebarContext)
  const submenuRef = useRef(null)
  const [top, setTop] = useState(null)

  // No desktop o flyout é position: fixed (a nav rola); alinha ao topo do item
  // e sobe o necessário para não sair pela base da tela.
  useLayoutEffect(() => {
    if (window.innerWidth < MOBILE_BREAKPOINT) return
    const anchor = anchorRef && anchorRef.current
    const submenu = submenuRef.current
    if (!anchor || !submenu) return
    const anchorTop = anchor.getBoundingClientRect().top
    const maxTop = window.innerHeight - submenu.offsetHeight - VIEWPORT_MARGIN
    setTop(Math.max(VIEWPORT_MARGIN, Math.min(anchorTop, maxTop)))
  }, [anchorRef])

  const handleClick = (e, item) => {
    e.preventDefault()
    if (item.disabled) return
    if (item.action === 'logout') {
      if (onNavigate) onNavigate()
      if (logout) logout()
      return
    }
    if (!item.url || item.url === '#') return
    history.push(item.url)
    if (onNavigate) onNavigate()
  }

  return (
    <div
      ref={submenuRef}
      className="app-sidebar__submenu"
      style={top !== null ? { top } : undefined}
      onMouseEnter={onKeep}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="app-sidebar__submenu-title">{title}</div>
      <ul className="app-sidebar__submenu-list">
        {items.map((child) => {
          const isActive =
            !child.disabled && child.url && child.url !== '#'
              ? (() => {
                  const [urlPath, urlSearch] = child.url.split('?')
                  const pathMatches =
                    location.pathname === urlPath || location.pathname.startsWith(`${urlPath}/`)
                  if (!pathMatches) return false
                  if (urlSearch) return location.search === `?${urlSearch}`
                  return true
                })()
              : false
          const className = [
            'app-sidebar__submenu-item',
            child.disabled ? 'is-disabled' : '',
            isActive ? 'is-active' : ''
          ]
            .filter(Boolean)
            .join(' ')
          return (
            <li key={child.key || child.name} className={className}>
              <a href={child.url || '#'} onClick={(e) => handleClick(e, child)}>
                {child.name}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default withRouter(SidebarSubmenu)
